var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, ViewChild, CustomElement, Watch, Utils, PropertyConverters, Defaults, CustomElementUtils } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemPropertyPickerElement = class PacemPropertyPickerElement extends PacemBaseElement {
    get inputFields() {
        return [this._select];
    }
    toggleReadonlyView(readonly) {
        this._select.readonly = readonly;
    }
    onChange(evt) {
        return Utils.fromResult(this.value = this._select.value);
    }
    acceptValue(val) {
        this._select.value = val;
    }
    getViewValue(value) {
        return this._select.viewValue;
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Element.convert(attr);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._databind();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'target':
                    this._databind();
                    break;
            }
        }
    }
    _databind() {
        const props = [], 
        // recursive fn
        fnRec = (container, prop, name) => {
            const val = container[prop];
            if (typeof val === 'object' && val != null && !Utils.isArray(val)) {
                for (let key of Object.keys(val)) {
                    const fullName = name + '.' + key;
                    // add nested
                    props.push(fullName);
                    // try again (recursively)
                    fnRec(val, key, fullName);
                }
            }
        };
        let src = this.target;
        if (!Utils.isNull(src)) {
            let observed = CustomElementUtils.getWatchedProperties(src);
            for (let obs of observed) {
                let name = obs.name;
                // add straight
                props.push(name);
                // dig nested stuff
                fnRec(src, name, name);
            }
        }
        this._select.datasource = props.sort();
    }
};
__decorate([
    ViewChild(P + '-select')
], PacemPropertyPickerElement.prototype, "_select", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemPropertyPickerElement.prototype, "target", void 0);
PacemPropertyPickerElement = __decorate([
    CustomElement({
        tagName: P + '-property-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-select></${P}-select>`
    })
], PacemPropertyPickerElement);
export { PacemPropertyPickerElement };
